import responsive from '../../../../Services/responsive';

const {
  SCREEN_WIDTH_SMALL,
  SCREEN_WIDTH_MEDIUM,
  SCREEN_WIDTH_LARGE,
  SCREEN_WIDTH_XLARGE,
  MEDIA_MATCH_SMALL,
  MEDIA_MATCH_MEDIUM,
  MEDIA_MATCH_LARGE,
  MEDIA_MATCH_XLARGE,
} = responsive;

export {
  SCREEN_WIDTH_SMALL,
  SCREEN_WIDTH_MEDIUM,
  SCREEN_WIDTH_LARGE,
  SCREEN_WIDTH_XLARGE,
  MEDIA_MATCH_SMALL,
  MEDIA_MATCH_MEDIUM,
  MEDIA_MATCH_LARGE,
  MEDIA_MATCH_XLARGE,
};
